import {
  doc,
  getDoc,
  getDocs,
  collection,
  query,
  limit,
  addDoc,
  updateDoc,
  deleteDoc,
  startAfter,
  getCountFromServer,
  orderBy,
  where,
} from "firebase/firestore";
import { db } from "config/firebase";

const getDocument = (id) => {
  return doc(db, "promises", id);
};

export const getData = async (reference) => {
  if (reference) {
    const docSnap = await getDoc(reference);
    return docSnap.exists() ? { id: docSnap?.id, ...docSnap.data() } : null;
  }
  return null;
};

export const getPromises = async (last, limitCount = 50) => {
  try {
    // Query to get the promises
    const q = last
      ? query(
          collection(db, "promises"),
          orderBy("createdAt", "desc"),
          startAfter(last),
          limit(limitCount),
        )
      : query(
          collection(db, "promises"),
          orderBy("createdAt", "desc"),
          limit(limitCount),
        );

    const documentSnapshots = await getDocs(q);

    // Get the last visible document
    const lastVisible =
      documentSnapshots.docs[documentSnapshots.docs.length - 1];

    const promises = documentSnapshots.docs.map((doc) => {
      return { ...doc.data(), id: doc.id };
    });

    let totalPromisesCount = promises.length;
    let counts = null;

    if (!last) {
      try {
        const [countSnapshot, finishedSnapshot, pendingSnapshot] =
          await Promise.all([
            getCountFromServer(query(collection(db, "promises"))),
            getCountFromServer(
              query(
                collection(db, "promises"),
                where("type", "==", "finished")
              )
            ),
            getCountFromServer(
              query(
                collection(db, "promises"),
                where("type", "==", "pending")
              )
            ),
          ]);
        totalPromisesCount = countSnapshot.data().count;
        const finished = finishedSnapshot.data().count;
        const pending = pendingSnapshot.data().count;
        const active = Math.max(0, totalPromisesCount - finished - pending);
        counts = {
          total: totalPromisesCount,
          finished,
          pending,
          active,
        };
      } catch (countErr) {
        console.warn("Failed to get count breakdown, using fallback", countErr);
        const countQuery = query(collection(db, "promises"));
        const countSnapshot = await getCountFromServer(countQuery);
        totalPromisesCount = countSnapshot.data().count;
        counts = {
          total: totalPromisesCount,
          finished: 0,
          pending: 0,
          active: totalPromisesCount,
        };
      }
    }

    return { promises, last: lastVisible, totalPromisesCount, counts };
  } catch (error) {
    console.error(`Error while getting promises: ${error}`);
    return error;
  }
};

export const getPromisesLength = async () => {
  const countQuery = query(collection(db, "promises"));
  const countSnapshot = await getCountFromServer(countQuery);
  const totalPromisesCount = countSnapshot.data().count;
  return totalPromisesCount;
};

export const getPromiseById = async (id) => {
  const docRef = getDocument(id);
  const docSnap = await getDoc(docRef);
  const lesson = docSnap.data();
  return docSnap.exists() ? { id: docSnap.id, ...lesson, reviewers: [] } : null;
};

export const createPromise = async (promise) => {
  try {
    const newPromise = await addDoc(collection(db, "promises"), promise);
    return newPromise;
  } catch (e) {
    console.error(`Error while creating promise ${e}`);
    return false;
  }
};

export const updatePromises = async (id, data) => {
  try {
    await updateDoc(getDocument(id), data);
  } catch (e) {
    console.error(`Error while updating promise ${e}`);
    return false;
  }
};

export const deletePromise = async (id) => {
  try {
    await deleteDoc(getDocument(id));
  } catch (e) {
    console.error(`Error while deleting promise ${e}`);
    return false;
  }
};
